import React from 'react';
import SubHeading from '../SubHeading/SubHeading';
import {motion } from 'framer-motion'




import './Newsletter.css';

const Newsletter = () => (
  <motion.div
   whileInView={{scale: [0, 1], opacity: [0,1]}}
            transition={{duration: 0.8, type: 'spring'}}
   className='w-full flex flex-col justify-center border-yellow-300 border px-8 py-16'>
    <div className="w-full z-40 text-center flex flex-col justify-center">
      <SubHeading title="Newsletter" className="text-yellow-200 z-40" />
      <h1 className='text-4xl sm:text-6xl font-bold font-main  text-yellow-300'>Subscribe To Our News Letter</h1>
      <p className='text-white mb-4'>Never Miss Latest Updates</p>
    <div className="input mt-8 flex text-center justify-center flex-col sm:flex-row place-items-center">
      <input type="email" placeholder='Enter Your Email address' className='sm:w-[620px] w-fit mb-2 border-yellow-200 border rounded-md font-submain mr-8 py-2 px-4 ml-4 bg-[#0c0c0c] text-center'/>
      <button className='p-2 bg-yellow-300 mt-3 sm:mt-0'>Subscribe</button>
    </div>
    </div>
  </motion.div>
);

export default Newsletter;
